module.exports = __webpack_public_path__ + "static/media/sale-icon3.c1682434.svg";